import React from 'react';

const Benifits = () => {
  return (
    <div className="services section">
    <div className="container mx-auto py-16">
      <div className="flex flex-col items-center">
        <div className="mb-8 text-center" style={{zIndex:'4'}}>
          <h4 id="Benefits" className="text-4xl font-bold mb-2">
            {/* Amazing <em>Services &amp; Features</em> for you */}
            Benifits
          </h4>
          {/* <img
            src="../src/asset/image/heading-line-dec.png"
            alt=""
            className="mx-auto"
          /> */}
          {/* <p className="mt-4">
            If you need the greatest collection of HTML templates for your
            business, please visit{" "}
            <a
              rel="nofollow"
              href="https://www.toocss.com/"
              target="_blank"
              className="text-blue-500"
            >
              TooCSS
            </a>{" "}
            Blog. If you need to have a contact form PHP script, go to{" "}
            <a
              href="https://templatemo.com/contact"
              target="_parent"
              className="text-blue-500"
            >
              our contact page
            </a>{" "}
            for more information.
          </p> */}
        </div>
        <div className="flex flex-wrap justify-center mt-8">
          <div className="lg:w-1/4 md:w-1/2 w-full lg:px-4">
            <div className="service-item first-service bg-gray-100 p-6 rounded-lg text-center">
              {/* <div className="icon mb-4" /> */}
              <h4 className="text-lg font-bold mb-2">⏱ Time-Saving</h4>
              <p className="text-gray-600 text-justify">
             Udemy Summary: Harness the Power of OpenAI provides concise summaries, letting you understand video content in a fraction of the original video length.
              </p>
              {/* <div className="text-button mt-4">
                <a href="#" className="text-blue-500">
                  Read More <i className="fa fa-arrow-right" />
                </a>
              </div> */}
            </div>
          </div>
          <div className="lg:w-1/4 md:w-1/2 w-full lg:px-4">
            <div className="service-item second-service bg-gray-100 p-6 rounded-lg text-center">
              {/* <div className="icon mb-4"></div> */}
              <h4 className="text-lg font-bold mb-2">🧰 Convenience</h4>
              <p className="text-gray-600 text-justify">Get an accurate summary without having to watch the entire video or course. This is the ideal solution for viewers with limited study time.</p>
            </div>
          </div>
          <div className="lg:w-1/4 md:w-1/2 w-full lg:px-4">
            <div className="service-item second-service bg-gray-100 p-6 rounded-lg text-center">
              {/* <div className="icon mb-4"></div> */}
              <h4 className="text-lg font-bold mb-2">📝 Download to PDF</h4>
              <p className="text-gray-600 text-justify"> Udemy's flexibility lets you easily convert your course transcript into a PDF, offering a convenient way to store and study the material offline.</p>
            </div>
          </div>
          <div className="lg:w-1/4 md:w-1/2 w-full lg:px-4">
            <div className="service-item second-service bg-gray-100 p-6 rounded-lg text-center">
              {/* <div className="icon mb-4"></div> */}
              <h4 className="text-lg font-bold mb-2">🥰 User-Friendly</h4>
              <p className="text-gray-600 text-justify">Our tool is easy to use - just click the button with the chatGPT icon on each video and a summary will be generated in seconds.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default Benifits;
